// extracted by mini-css-extract-plugin
export default {"tag":"UserOrgSwitch_tag__EfCYp","active":"UserOrgSwitch_active__bTTXc"};